import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import {
  Container,
  Content,
  Form,
  NameInput,
  Title,
  Description,
  SectionBtn,
  Footer,
  SectionUteis,
  TitleUteis,
  SectionList,
  ListAll,
  ListItem,
  SectionCopyright,
  TitleCopyright,
  TitleSociais,
  SectionSociais,
  FooterMobile,
  DivCenter,
} from './styles';

import api from '~/services/api';
import history from '~/services/history';

import InputPrimary from '~/components/Site/Inputs/InputPrimary';
import BtnSend from '~/components/Site/Buttons/BtnSecondary';

export default function ForgotPassword() {
  const [newPassword, setNewPassword] = useState();
  const [confirmNewPassword, setConfirmNewPassword] = useState();
  const [status, setStatus] = useState(true);

  useEffect(() => {
    async function checkIdAndKey() {
      const params = window.location.pathname.split('/');

      try {
        const userId = params[params.length - 2];
        const userKey = params[params.length - 1];

        const url = `/recovery-password/${userId}/${userKey}`;

        await api.get(url);

        setStatus(true);
      } catch (error) {
        setStatus(false);
      }
    }
    checkIdAndKey();
  }, []);

  const handleNewPassword = e => setNewPassword(e.target.value);
  const handleConfirmNewPassword = e => setConfirmNewPassword(e.target.value);

  const handleSubmit = async e => {
    e.preventDefault();

    if (newPassword !== confirmNewPassword) {
      return toast.error(
        'Verifique se os campos de senha e confirmação de senha coincidem exatamente.'
      );
    }
    const params = window.location.pathname.split('/');

    try {
      const userId = params[params.length - 2];
      const userKey = params[params.length - 1];

      const url = `/recovery-password/${userId}/${userKey}`;

      const request = {
        password: newPassword,
      };

      await api.patch(url, request);

      toast.success('Senha Redefinida com Sucesso.');
      history.push('/login');
    } catch (error) {
      toast.error('Não foi possível realizar essa operação. Tente novamente.');
    }
  };

  return (
    <Container>
      {status ? (
        <Content>
          <Form onSubmit={handleSubmit}>
            <Title>Redefinir a senha</Title>
            <Description>Insira sua nova senha</Description>
            <NameInput>Senha</NameInput>
            <InputPrimary
              name="newPassword"
              type="password"
              value={newPassword}
              onChange={handleNewPassword}
            />
            <NameInput>Confirmar Senha</NameInput>
            <InputPrimary
              name="confirmNewPassword"
              type="password"
              value={confirmNewPassword}
              onChange={handleConfirmNewPassword}
            />
            <SectionBtn>
              <BtnSend
                title="ENVIAR"
                type="submit"
                styles={{ width: '100%' }}
              />
            </SectionBtn>
          </Form>
        </Content>
      ) : (
        <Content>
          <DivCenter>
            <Title>Código de Verificação Inválido</Title>
            <SectionBtn>
              <BtnSend
                title="Esqueci minha Senha"
                onClick={() => history.push('/esqueceu-senha')}
                styles={{ width: '100%' }}
              />
            </SectionBtn>
          </DivCenter>
        </Content>
      )}
      <Footer>
        <SectionUteis>
          <SectionList>
            <TitleUteis>Links Úteis</TitleUteis>
            <ListAll>
              <ListItem>Home</ListItem>
              <ListItem>Contato</ListItem>
              <ListItem>Produto</ListItem>
              <ListItem>Fale Conosco</ListItem>
            </ListAll>
          </SectionList>
          <SectionCopyright>
            <TitleCopyright>
              2020 - Meu Plantão - Todos os direitos reservados
            </TitleCopyright>
          </SectionCopyright>
          <SectionSociais>
            <a href="https://www.facebook.com/MeuPlantao" target="_blank">
              <FaFacebook
                size={30}
                color="var(--background-alt)"
                style={{ marginRight: 40 }}
              />
            </a>
            <a href="https://www.instagram.com/meuplantao/" target="_blank">
              <FaInstagram
                size={30}
                color="var(--background-alt)"
                style={{ marginRight: 40 }}
              />
            </a>
            <a href="#" target="_blank">
              <FaWhatsapp size={30} color="var(--background-alt)" />
            </a>
          </SectionSociais>
        </SectionUteis>
      </Footer>
      <FooterMobile>
        <TitleSociais>Siga-nos nas redes sociais</TitleSociais>
        <SectionSociais>
          <a href="https://www.facebook.com/MeuPlantao" target="_blank">
            <FaFacebook
              size={30}
              color="var(--background-alt)"
              style={{ marginRight: 40 }}
            />
          </a>
          <a href="https://www.instagram.com/meuplantao/" target="_blank">
            <FaInstagram
              size={30}
              color="var(--background-alt)"
              style={{ marginRight: 40 }}
            />
          </a>
          <a href="#" target="_blank">
            <FaWhatsapp size={30} color="var(--background-alt)" />
          </a>
        </SectionSociais>
      </FooterMobile>
    </Container>
  );
}
